import * as React from "react";
import { useEffect, useState } from "react";
import { Accordion } from "../../Elements/Accordion";
import { useDrawingContext } from "../../Contexts/DrawingContext";
import { DrawPoints } from "./DrawPoints";
import { DrawPolylines } from "./DrawPolylines";
import { useRegistrationContext } from "../../Contexts/RegistrationContext";
import { PageId } from "../../Map/enums";
import { config } from "../../Map/config";
import { getMap } from "../DrawingForm";
import { AccordionInfo } from "./AccordionInfo";
import "./DrawingTools.scss";

const formId = PageId.DrawingForm;

const infoStrings = {
    scaleWarning: "Lai zīmētu, pietuviniet līdz mērogam 100m",
    missingDrawingsWarning: "Atzīmējiet vismaz vienu objektu kartē!"
};

export const DrawingTools = (): JSX.Element => {
    const [validate, setValidate] = useState<number>(0);
    const [scaleWarning, setScaleWarning] = useState<boolean>(true);
    const [drawingWarning, setDrawingWarning] = useState<boolean>(true);
    const [warnings, setWarnings] = useState<string[]>([]);
    const [maxHeight, setMaxHeight] = useState<number>(0);

    const { validateForm, onFormUpdated, setDrawingInfoVisible, drawnFeatures } = useRegistrationContext();
    const { setNewFeature, setDrawingAllowed } = useDrawingContext();

    useEffect(() => {
        setTimeout(() => {
            // timeout only when start from this page, because map is not ready yet
            getMap()
                .getLayers()
                .getArray()
                .find((l) => l.get("id") === config.default.drawingLayerId)
                .getSource()
                .on("addfeature", (e) => setNewFeature(e.feature));

            //@ts-ignore
            getMap().on("moveend", () => setScaleWarning(isDrawingProhibited()));
            setMaxHeight(document.getElementsByClassName("map-container")[0].clientHeight - 100);
        }, 200);
        // setDrawingInfoVisible(true);
    }, []);

    useEffect(() => {
        const validateThisForm =
            ((validateForm.split("-")[0] as unknown) as PageId) === formId ? Number(validateForm.split("-")[1]) : 1;
        if (validateThisForm !== validate) {
            setValidate(validateThisForm);
            !drawingWarning && onFormUpdated();
        }
    }, [validateForm, validate, drawingWarning]);

    useEffect(() => {
        setDrawingWarning(drawnFeatures.length === 0);
    }, [drawnFeatures]);

    useEffect(() => {
        const newWarnings = [];
        scaleWarning && newWarnings.push(infoStrings.scaleWarning);
        drawingWarning && newWarnings.push(infoStrings.missingDrawingsWarning);
        setWarnings(newWarnings);
    }, [scaleWarning, drawingWarning]);

    useEffect(() => {
        setDrawingAllowed(!scaleWarning);
    }, [scaleWarning]);

    const isDrawingProhibited = () =>
        //@ts-ignore
        document.mapScale > 5600;

    return (
        <Accordion maxHeight={maxHeight}>
            <div className="scrollable">
                <DrawPoints></DrawPoints>
                <DrawPolylines></DrawPolylines>
            </div>
            {warnings.length ? <AccordionInfo warnings={warnings}></AccordionInfo> : null}
        </Accordion>
    );
};
